export function buildCommonContext(userContextManager) {
    return {
        view: {
            referrer: document.referrer,
            url: window.location.href,
        },
        user: userContextManager.getContext(),
    };
}
//# sourceMappingURL=commonContext.js.map